module.exports = __webpack_public_path__ + "img/3-2-1.592f0dd5.svg";